import { useForecast } from '../hooks/useForecast';
import SummaryCard from '../components/SummaryCard';
import { useVariance } from '../hooks/useVariance';
import VarianceBarChart from '../components/VarianceBarChart';
import LoadingSpinner from '../components/LoadingSpinner';
import ErrorCard      from '../components/ErrorCard';
import { useNavigate }        from 'react-router-dom';
import RollingForecastChart   from '../components/RollingForecastChart';



function fmtCurrency(n) {
  if (n === null || n === undefined) return '—';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(n);
}

function Dashboard() {
  const { data, loading, error, refresh, lastSync } = useForecast();
  const { data: varData } = useVariance();

// ADD inside Dashboard:  
const navigate = useNavigate();
const alertThreshold = parseInt(localStorage.getItem('acct4cast_alert_threshold') || '15');
const alertCount = varData
  ? varData.variances.filter(v => Math.abs(v.variancePct) >= alertThreshold && !v.favorable && v.budget !== 0).length
  : 0;


//  if (loading) return <div className="page"><p>Loading dashboard...</p></div>;
//  if (error) return <div className="page"><p style={{ color: '#BE123C' }}>Error: {error}</p></div>;
  if (loading) return <div className="page"><LoadingSpinner message="Loading dashboard data from QuickBooks..." /></div>;
  if (error)   return <div className="page"><ErrorCard error={error} onRetry={refresh} /></div>;
  if (!data) return null;

  const { rateOfClimb, forecast, annualBudget, actuals } = data;
  const rocColor = rateOfClimb.climbing ? '#15803D' : '#BE123C';
  const syncStr = lastSync ? `Last sync: ${lastSync.toLocaleTimeString()}` : 'Not synced';

 
  return (
    <div className="page">
      {/* Header */}

      {lastSync && (
        <div style={{
          background: '#F8FAFC',
          border: '1px solid #E2E8F0',
          borderRadius: 6,
          padding: '0.4rem 1rem',
          marginBottom: '1.25rem',
          fontSize: '0.8rem',
          color: '#64748B',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <span>📡 Live QuickBooks data</span>
          <span>Last sync: {lastSync.toLocaleString()}</span>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2>DASHBOARD</h2>
        
        {alertCount > 0 && (
      <button
        onClick={() => navigate('/alerts')}
        style={{ background:'#BE123C', color:'#fff', border:'none',
                 borderRadius:12, padding:'0.2rem 0.7rem',
                 fontSize:'0.8rem', fontWeight:700, cursor:'pointer' }}>
        🚨 {alertCount} ALERT{alertCount!==1?'S':''}
      </button>
        )}

        <button onClick={refresh}
          style={{ padding: '0.4rem 1rem', background: '#0E7C7B', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
          Refresh
        </button>

      </div>

      {/* Summary Cards */}
      <div style={{ display:'flex', gap:'1rem', marginBottom:'2rem' }}>
        {[
          { card: <SummaryCard icon="💰" title="YTD Net Income"
                    value={fmtCurrency(actuals.net)}
                    sub={`Budget: ${fmtCurrency(annualBudget.net/12*data.period.closedMonths)}`}
                    color="#0E7C7B" />, path:'/forecast' },
          { card: <SummaryCard icon={rateOfClimb.arrow} title="Rate of Climb"
                    value={rateOfClimb.verdict}
                    sub={`Forecast: ${fmtCurrency(forecast.net)} vs ${fmtCurrency(annualBudget.net)}`}
                    color={rocColor} />, path:'/forecast' },
          { card: <SummaryCard icon="🚨" title="Active Alerts"
                    value={alertCount === 0 ? 'All Clear ✓' : `${alertCount} Account${alertCount!==1?'s':''}`}
                    sub={`Threshold: ${alertThreshold}%`}
                    color={alertCount>0?'#BE123C':'#15803D'} />, path:'/alerts' },
        ].map(({card,path},i) => (
          <div key={i} onClick={()=>navigate(path)}
            style={{ flex:1, cursor:'pointer', transition:'transform 0.1s' }}
            onMouseEnter={e=>e.currentTarget.style.transform='translateY(-2px)'}
            onMouseLeave={e=>e.currentTarget.style.transform='none'}
          >
            {card}
          </div>
        ))}
      </div>


      {/* Charts Side-by-Side Container */}
      <div className="chart-grid">
        
        {/* Chart 1: Top 5 Variances */}
        <div style={{ 
          background: '#fff', borderRadius: 8, padding: '1rem', aspectRatio: '16 / 10',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)', overflow: 'hidden', display: 'flex', flexDirection: 'column'
        }}>
          <h3 style={{ color: '#1B2A4A', fontSize: '1rem', marginBottom: '0.75rem' }}>Top 5 Variances</h3>
          <div style={{ flex: 1, minHeight: 0 }}>
            {varData && <VarianceBarChart variances={varData.variances} />}
          </div>
        </div>

        
        {/* Chart 3: Rolling Forecast */}
        <div style={{ background:'#fff', borderRadius:8, padding:'1.5rem',
              boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1rem' }}>
          <h3 style={{ color:'#1B2A4A', fontSize:'0.95rem' }}>Year Forecast</h3>
          <button onClick={()=>navigate('/forecast')}
            style={{ fontSize:'0.75rem', color:'#0E7C7B', background:'none',
                    border:'none', cursor:'pointer', textDecoration:'underline' }}>
            Full view →
          </button>
        </div>
        <RollingForecastChart
          monthlyData={data.monthlyData}
          closedMonths={data.period.closedMonths}
        />
      </div>








      </div>
    </div>
  );
}

export default Dashboard;